export default "__VITE_PUBLIC_ASSET__3cfcdfe1__"